/* global G */
import { acl } from 'app/_shared/events/acl'
import { persistScroll } from 'app/_shared/events'
import getRecents from 'app/recent/event/getRecents'
import detail from 'app/recent/event/detail'
import hasMultipleIdsAndType from 'app/_shared/events/search/query/hasMultipleIdsAndType'
import listOrganisationTypes from 'app/_shared/events/collection/listOrganisationTypes'
import listTicketTypes from 'app/_shared/events/collection/listTicketTypes'
import listRequestStatus from 'app/_shared/events/collection/listRequestStatus'
import remember from 'app/_shared/events/remember'
import { chain } from 'app/_shared/events/util'

export default {
  acl: {
    acl,
  },
  onOpen: {
    getRecents,
  },
  onClick: {
    detail,
  },
  query: {
    hasMultipleIdsAndType,
  },
  getOrganisationType: {
    listOrganisationTypes,
  },
  getTicketType: {
    listTicketTypes,
  },
  getStatus: {
    listRequestStatus,
  },
  onPage: {
    remember,
  },
  onScroll: {
    persistScrollAndRemember: chain(
      persistScroll,
      remember,
    ),
  },
}
